[
  {
    "id": "TB-B8P-L302-001",
    "module": "Taalbegrip",
    "difficulty": 302,
    "question": "Wat is een 'eufemisme'?",
    "options": [
      "Verzachtende uitdrukking",
      "Harde uitdrukking",
      "Scheldwoord",
      "Grapje"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "stijl",
    "subSkill": "stijlfiguren",
    "familyId": "TB-EUFEMISME",
    "explanation": "Een eufemisme maakt iets minder hard. Bijv. 'heengegaan' in plaats van 'gestorven'.",
    "distractorExplanations": {
      "1": "Dat is dysfemisme.",
      "2": "Niet waar.",
      "3": "Niet waar."
    }
  },
  {
    "id": "TB-B8P-L302-002",
    "module": "Taalbegrip",
    "difficulty": 302,
    "question": "Wat betekent 'expliciet'?",
    "options": [
      "Uitdrukkelijk",
      "Verborgen",
      "Onduidelijk",
      "Snel"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-EXPLICIET",
    "explanation": "Expliciet betekent dat je het heel duidelijk en uitdrukkelijk zegt.",
    "distractorExplanations": {
      "1": "Impliciet.",
      "2": "Vaag.",
      "3": "Niet waar."
    }
  },
  {
    "id": "TB-B8P-L302-003",
    "module": "Taalbegrip",
    "difficulty": 302,
    "question": "Wat is 'ironie'?",
    "options": [
      "Milde spot (het omgekeerde zeggen)",
      "Harde spot",
      "Liefde",
      "Haat"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "stijl",
    "subSkill": "stijlfiguren",
    "familyId": "TB-IRONIE",
    "explanation": "Bij ironie zeg je vaak het omgekeerde van wat je bedoelt, om te grappen.",
    "distractorExplanations": {
      "1": "Sarcasme.",
      "2": "Niet waar.",
      "3": "Niet waar."
    }
  },
  {
    "id": "TB-B8P-L302-004",
    "module": "Taalbegrip",
    "difficulty": 302,
    "question": "Wat is een 'tautologie'?",
    "options": [
      "Twee woorden met dezelfde betekenis",
      "Twee tegengestelde woorden",
      "Een rijmwoord",
      "Een fout woord"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "stijl",
    "subSkill": "stijlfiguren",
    "familyId": "TB-TAUTOLOGIE",
    "explanation": "Tautologie: gratis en voor niets. Twee keer hetzelfde zeggen.",
    "distractorExplanations": {
      "1": "Antithese.",
      "2": "Rijm.",
      "3": "Niet per se fout (stijlfiguur)."
    }
  },
  {
    "id": "TB-B8P-L302-005",
    "module": "Taalbegrip",
    "difficulty": 302,
    "question": "Wat betekent 'alternatief'?",
    "options": [
      "Andere mogelijkheid",
      "Hetzelfde",
      "Verplichting",
      "Oplossing"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-ALTERNATIEF",
    "explanation": "Een alternatief is een andere keuze of mogelijkheid.",
    "distractorExplanations": {
      "1": "Identiek.",
      "2": "Moet.",
      "3": "Niet per se."
    }
  }
]